<template>
  <v-dialog max-width="600px" v-model="showDialogAddNewClientService" @update:model-value="handleDialogClose"
            @keydown.esc="handleEscape">
    <v-card>
      <v-card-title>
        <h4 class="highlighted">Buy SIM Card</h4>
      </v-card-title>
<!--      newClientLevel0-->
      <v-card-text v-if="true">
        <v-row class="border0">
          <v-col  cols="12">
            <v-autocomplete name="Select Service"
                            v-model="newPrepaidCardServiceID"
                            v-model:search="prepaidCardSearchText"
                            :items="prepaidCardServicesList"
                            item-value="id"
                            item-text="name"
                            label="Select Prepaid Card "
                            outlined
                            dense
                            clearable
                            auto-select-first
                            @focus="prepaidCardSearchText = ''"
            >
            </v-autocomplete>
          </v-col>

        </v-row>
        <v-row class="justify-space-between">
          <v-col  cols="4">
            <v-text-field  type="number" v-model.number="numberOfSims" label="... number of SIMs" :rules="inputRules" @input="updateSimRows"></v-text-field>
          </v-col>
          <v-col  class="border0">
            <v-btn-toggle v-model="showSimsDetails"
                          mandatory
                          tile
            >
              <div class="relative top10">Choose phone Number</div>
              <v-btn
                  class="ml-4"
                  :value="true"
                  color="success"
                  size="large"
                  depressed
              >
                Yes
              </v-btn>
              <v-btn
                  :value="false"
                  color="error"
                  size="large"
                  depressed
              >
                No
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

        <v-row></v-row>

        <div v-if="showSimsDetails" class="mt-4">
          <v-row v-for="(sim, index) in sims" :key="index" class="border0  align-center">
            <v-col cols="3">
              <v-label>SIM {{ index + 1 }}</v-label>
            </v-col>
            <v-col cols="5">
              <v-chip v-if="sim.msisdn" color="success" size="small">
                {{ sim.msisdn }}
              </v-chip>
              <span v-else class="text-grey">No number selected</span>
            </v-col>
            <v-col cols="4">
              <v-btn
                :color="sim.msisdn ? 'secondary' : 'primary'"
                size="small"
                @click="selectMsisdn(index)"
              >
                {{ sim.msisdn ? 'Change' : 'Select MSISDN' }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col>
            <v-label :value="package_details"></v-label>
          </v-col>
        </v-row>


        <v-divider class="mt-2"></v-divider>

        <v-card-subtitle class="font-weight-bold"></v-card-subtitle>

        <v-radio-group
            v-model="deliveryTypeID"
            row
            dense
        >
          <v-card-title>Delivery Type</v-card-title>
          <v-row justify="space-around" class="mt-3 mb-3">
            <v-col>
              <v-radio
                v-for="dt in deliveryTypes"
                :key="dt.id"
                :value="dt.id"
                :label="`${dt.name} (${dt.cost} RON)`"
              ></v-radio>
            </v-col>
          </v-row>
        </v-radio-group>

        <!-- Courier Delivery Form -->
        <div v-if="isCourierDelivery" class="courier-form mt-4">
          <v-card-title>Delivery Details</v-card-title>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="courierForm.name" label="Nume destinatar" :rules="inputRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field v-model="courierForm.street" label="Strada" :rules="inputRules"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="courierForm.number" label="Nr."></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="courierForm.building" label="Bloc / Etaj / Apartament"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="courierForm.sector" label="Sector"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="courierForm.county" label="Județ" :rules="inputRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="courierForm.country" label="Țara" :rules="inputRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="courierForm.email" label="Email" type="email"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="courierForm.phone" label="Telefon contact" :rules="inputRules"></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row justify="space-around" class="mt-3 mb-3">
          <v-btn  @click="closeDialogAddNewClientService()" large color="danger">Cancel</v-btn>
          <v-btn large color="primary" @click="addNewPrepaidSimClientServiceLocal" class="success " :loading="loading">Buy SIM</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <SelectAvailableMsisdn
    v-if="showDialogSelectPersonalMsisdn"
    :currentSimIndex="currentSimIndex"
    @msisdnSelected="onMsisdnSelected"
    @dialogSelectAvailableMsisdnEscapedEvent="dialogSelectPersonalMsisdnEscaped"
  />
  <v-dialog max-width="600px" v-model="showDialogRedirectToOnlinePayment" @update:model-value="handleDialogClose"
            @keydown.esc="handleEscape">
    <v-card>
      <v-card-title>
        <h4 class="highlighted">Order added, redirect to BT Pay </h4>

      </v-card-title>
      <!--      newClientLevel0-->
      <v-card-text v-if="true">
        <v-row class="border0 ">
          <v-col  cols="12">
            <a :href="btUrl" target="_blank" >Link to BT Pay</a>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'
// import db from '@/fb'

import {log} from "@/composables/useLog";
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {getPrepaidCardsServicesList} from "@/composables/useGetServicesAPI";
import SelectAvailableMsisdn from "@/components/SelectAvailableMsisdn.vue"
import {addNewClientService} from "@/composables/useAddNewClientService";
export default {
  props:["showAddNewClientService"],
  emits:["dialogClosedEvent", "newClientServiceAddedEvent"],
  components:{
    SelectAvailableMsisdn
  },
  data() {
    return {
      imsiServiceTypes:[],
      prepaidCardServicesList:[],
      newPrepaidCardServiceID:null,
      prepaidCardSearchText: '',
      numberOfSims:1,
      selectSpecialMsisdn:false,
      showSimsDetails:true,
      showSimsDetailsButtonTitle:'Close SIMs details',
      showDialogBuyNewSimCard:true,
      package_details:null,
      sims:[],
      showDialogSelectPersonalMsisdn:false,
      currentSimIndex:null,
      currentMsisdnId:null,
      selectedService:null,
      deliveryTypeID:1,
      deliveryTypes:[],
      courierForm: {
        name: '',
        street: '',
        number: '',
        building: '',
        sector: '',
        county: '',
        country: 'Romania',
        email: '',
        phone: ''
      },
      showDialogAddNewClientService:true,
      showDialogRedirectToOnlinePayment:false,
      subclientsList:[],
      clientTypes:[],
      listaMsisdn:[],
      btUrl:"",


      inputRules: [
        v => !!v || 'This field is required',

      ],
      inputRulesPrice: [
        (value) => !!value || "This field is required.",
        (value) =>
            /^\d{1,6}(\.\d{1,2})?$/.test(value) ||
            "Must be a number with up to 6 digits and 2 decimals.",
      ],
      inputRulesName: [
        v => !!v || 'This field is required',
        v => v.length >= 5 || 'Minimum length is 5 characters'
      ],
      loading: false,
    }
  },
  methods: {
   checkNewTabPermission(url) {
      const newTab = window.open('', '_blank'); // Try to open a new tab
      if (newTab) {
        // New tab was successfully opened
        newTab.location.href = url; // Redirect to the payment processor
        return true;
      } else {
        // Failed to open a new tab (e.g., blocked by the browser or popup blocker)
        return false;
      }
    },
    handleDialogClose(value) {
      // Emitted when dialog visibility changes
      log("am primit eveniment ca v-dialog s.a inchis")
      if (!value) {
        // alert("am primit eveniment ca v-dialog s.a inchis si no value")
        this.$emit('dialogClosedEvent');
      }
    },
    handleEscape() {
      // alert("am primit eveniment ca v-dialog a apasat escape")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogEscapedEvent');
    },
    setShowSimsDetails() {
      this.showSimsDetails=!this.showSimsDetails
      if(this.showSimsDetails==true){
        this.showSimsDetailsButtonTitle='Close SIMs details'
      }else{
        this.showSimsDetailsButtonTitle='Show SIMs details'
      }
    },
    redirectToPaymentProcessor(url) {
     log("welcome in redirectToPaymentProcessor("+url+")")
      // const isAllowed = this.checkNewTabPermission(url);
      // if (!isAllowed) {
      //   // Notify the user if the new tab is blocked
      //   alert('Unable to open a new tab. Please enable pop-ups in your browser.');
      //   this.showDialogRedirectToOnlinePayment=true
      // }
      // else{
      //   alert('Redirectionam catre procesatorul BT');
        this.showDialogRedirectToOnlinePayment=true
      // }
    },
    async addNewPrepaidSimClientServiceLocal() {
      // alert("calling addNewPrepaidSimClientServiceLocal")
      if(this.newPrepaidCardServiceID==null){
        alert("Alegeti tipul de SIM dorit")
      }else{
        const form = {
          newClientServiceClientID:this.client_id,
          newClientServiceServiceID:this.newPrepaidCardServiceID,
          newClientServiceNumberOfSims:this.numberOfSims,
          newClientServiceDeliveryTypeID:this.deliveryTypeID,
          newClientServiceListaMsisdn:this.sims,
          courierDeliveryDetails: this.isCourierDelivery ? this.courierForm : null,
        }
        log(form)
        this.loading = true
        addNewClientService(this.token,form).then((response)=>{
          log("response din addNewClientService prepaid card cu plata online:")
          log(response)
          if(response.error==true){
            alert(response.message)
          }else{
            // alert(response.btUrl)
            this.btUrl=response["btUrl"]
            // this.$emit("newClientServiceAddedEvent",this.btUrl);
            this.showDialogAddNewClientService=false
            this.redirectToPaymentProcessor()
          }
          this.loading=false
        })
      }
    },



    updateSimRows() {
      // Adjust the number of rows to match the number of SIMs
      const newSims = [];
      for (let i = 1; i <= this.numberOfSims; i++) {
        newSims.push({ msisdn: null }); // Example structure for SIM data
      }
      this.sims = newSims;
    },
    selectMsisdn(index) {
      // Handle the MSISDN selection logic for the given SIM
      log(`Select MSISDN for Sim nr ${index + 1}`);
      this.showDialogSelectPersonalMsisdn=true
      this.showDialogAddNewClientService=false
      this.currentSimIndex=index
    },
    closeDialogAddNewClientService() {
      // Handle the MSISDN selection logic for the given SIM
      this.showDialogSelectPersonalMsisdn=false
      this.$emit('dialogClosedEvent');
    },
    dialogSelectPersonalMsisdnEscaped(index) {
      // Handle the MSISDN selection logic for the given SIM
      log(`called dialogSelectPersonalMsisdnEscaped for Sim nr ${index + 1}`);
      this.showDialogSelectPersonalMsisdn=false
      this.showDialogAddNewClientService=true
      this.currentSimIndex=index
    },
    dialogSelectPersonalMsisdnClosed(simIndex,msisdn_id) {
      // Handle the MSISDN selection logic for the given SIM
      log(`ne.am intors in componenta parinte BuyNewSimCardService in fnctia dialogSelectPersonalMsisdnClosed`);
      this.showDialogSelectPersonalMsisdn=false
      this.showDialogAddNewClientService=true
      this.currentSimIndex=simIndex
      this.currentMsisdnId=msisdn_id
    },
    onMsisdnSelected(data) {
      // Received from SelectAvailableMsisdn: { simIndex, msisdn_id, msisdn, billing_type, billing_period_id, price, currency }
      console.log("MSISDN selected:", data)

      // Update the SIM at the given index with the selected MSISDN and billing info
      if (data.simIndex !== null && this.sims[data.simIndex]) {
        this.sims[data.simIndex].msisdn_id = data.msisdn_id
        this.sims[data.simIndex].msisdn = data.msisdn
        this.sims[data.simIndex].billing_type = data.billing_type
        this.sims[data.simIndex].billing_period_id = data.billing_period_id
        this.sims[data.simIndex].billing_period_name = data.billing_period_name
        this.sims[data.simIndex].price = data.price
        this.sims[data.simIndex].currency = data.currency
      }

      // Close child dialog and show main dialog
      this.showDialogSelectPersonalMsisdn = false
      this.showDialogAddNewClientService = true
    },
  },

  created() {
    const { getLoggedIn, user, loggedIn, token } = useGetLoggedIn();
    getLoggedIn().then(() => {
      this.showDialogAddNewClientService=true;
// Logs from the provided instructions
      log("dupa created in Dashboard avem:");
      log("autorizare in Dashboard after getLoggedIn");
      log("user:");
      log(user);
      log("loggedIn: " + loggedIn.value);
      log("token: " + token.value);
      this.client_id=user.value.client_id
      this.token = token.value
      getPrepaidCardsServicesList(this.token,this.client_id).then((response) => {
        log("------------aici after getPrepaidCardsServicesList----------")
        this.prepaidCardServicesList= response.services_list
        log(this.prepaidCardServicesList)
        if (response.delivery_types) {
          this.deliveryTypes = response.delivery_types
          log("deliveryTypes loaded:")
          log(this.deliveryTypes)
        }
      })
      this.updateSimRows()
    });

  },
  computed: {
    isCourierDelivery() {
      const courierType = this.deliveryTypes.find(dt => dt.name && dt.name.toLowerCase().includes('courier'));
      return courierType ? this.deliveryTypeID === courierType.id : this.deliveryTypeID === 1;
    },
    formattedDate () {
      console.log(this.due)
      return this.due ? format(this.due, 'Do MMM YYYY') : ''
    },
  },
  watch: {
    newClientServiceServiceID(service_id) {
      let service= this.available_services_list.find(service => service.id === service_id);
      log("am gsit service=")
      alert("managed_by_client_id="+service.managed_by_client_id)
      this.newClientPayToClientID=service.managed_by_client_id
    }
  },
}
</script>
